/**
 * SATIŞ ADAYLARI, KURUMLAR VE KREDİ — PANELİN ÖNBELLEK ANAHTARLARI
 * (kurum satışla açılır · Story B4, C2, D5).
 *
 * `invalidation.ts` dosya tavanına dayandığı için aile burada durur ve oraya
 * yayılır; anahtar uzayı ve harita TEKTİR (`CACHE_KEYS`, `INVALIDATION_MAP`).
 * Yalnız `apps/admin` okur. Kurum listesindeki kalan kredi ve sözleşme bitişi
 * kredi yazmalarından da bayatlar.
 */
export const PANEL_COMMERCE_CACHE_KEYS = {
    panelSalesInquiryList: 'panel/salesInquiries',
    panelSalesInquiryDetail: 'panel/salesInquiry',
    /** Kenar menünün "Yeni" rozeti (yalnız sayı, B-01). */
    panelSalesInquiryCounts: 'panel/salesInquiryCounts',
    panelOrganizationList: 'panel/organizations',
    panelOrganizationDetail: 'panel/organization',
    panelCreditOverview: 'panel/creditOverview',
    panelCreditLedger: 'panel/creditLedger',
    /** Referans (hediye) kodları listesi (P7); kullanım sayısı da bu listededir. */
    panelReferralCodeList: 'panel/referralCodes',
    /** Kurum detayının "Etkinlik sonrası" bölümü (belge ve anket Story 8). */
    panelOrganizationPostEvent: 'panel/organizationPostEvent',
};
const K = PANEL_COMMERCE_CACHE_KEYS;
const CREDIT_WRITE = [
    K.panelCreditOverview,
    K.panelCreditLedger,
    K.panelOrganizationList,
];
const CONTRACT_WRITE = [
    K.panelCreditOverview,
    K.panelOrganizationList,
];
const OWNER_WRITE = [
    K.panelOrganizationDetail,
    K.panelOrganizationList,
];
export const PANEL_COMMERCE_INVALIDATION = {
    // Satış adayı durumu: sekme sayaçları + detayın geçmişi + kenar menü rozeti.
    'panelSales/statusChange': [
        K.panelSalesInquiryList,
        K.panelSalesInquiryDetail,
        K.panelSalesInquiryCounts,
    ],
    // Kurum açma: yeni satır + adaydan açıldıysa adayın "bağlı kurum" alanı.
    'panelOrgs/provision': [
        K.panelOrganizationList,
        K.panelSalesInquiryList,
        K.panelSalesInquiryDetail,
    ],
    // Sahip daveti eylemleri: detaydaki sahip bloğu ve listedeki sahip hücresi.
    'panelOrgs/ownerResend': OWNER_WRITE,
    'panelOrgs/ownerReplace': OWNER_WRITE,
    // Kapak kaldırma (Story P1): yalnız detaydaki kapak kartı; liste kapak taşımaz.
    'panelOrgs/coverRemove': [K.panelOrganizationDetail],
    // Anketi kapat (belge ve anket Story 8): yalnız kurum detayının etkinlik sonrası bölümü.
    'panelOrgPostEvent/surveyDisable': [K.panelOrganizationPostEvent],
    // Kredi yazmaları: özet + defter + listedeki kalan kredi / sözleşme bitişi.
    // Hediyeli yükleme ayrıca kodun kullanım sayısını (P7 listesi) ve adaydaki
    // kod durumunu ("Bu kurum kullandı") bayatlatır.
    'panelCredits/grant': [...CREDIT_WRITE, K.panelReferralCodeList, K.panelSalesInquiryDetail],
    'panelCredits/reverse': CREDIT_WRITE,
    'panelCredits/contractCreate': CONTRACT_WRITE,
    'panelCredits/contractTerminate': CONTRACT_WRITE,
    // Referans kodu oluşturma ve düzenleme: liste (sekme sayaçları, durum etiketi).
    'panelReferral/create': [K.panelReferralCodeList],
    'panelReferral/update': [K.panelReferralCodeList],
};
/** Hiçbiri sunucuda çizilmez (panel Vite SPA'dır). */
export const PANEL_COMMERCE_SERVER_RENDERED = {
    [K.panelSalesInquiryList]: false,
    [K.panelSalesInquiryDetail]: false,
    [K.panelSalesInquiryCounts]: false,
    [K.panelOrganizationList]: false,
    [K.panelOrganizationDetail]: false,
    [K.panelCreditOverview]: false,
    [K.panelCreditLedger]: false,
    [K.panelReferralCodeList]: false,
    [K.panelOrganizationPostEvent]: false,
};
//# sourceMappingURL=invalidation-panel-commerce.js.map